import {Component, OnInit, OnDestroy} from '@angular/core';
//import {FormBuilder} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import { environment } from '../../environments/environment';
// import {PatientInformation} from '../patient-information-list/model/patient-information.model';
// import {PatientInformationDetailsService} from './service/patient-information-details.service';
import {Subscription} from 'rxjs';
import {AuthService} from '../shared/auth/auth.service';
@Component({
  selector: 'home',
  templateUrl: './home.component.html'
})
export class HomeComponent {
  baseSystem = environment.baseSystem;

  constructor(private _route: ActivatedRoute,
    private _router: Router,
    public authService:AuthService) {
}
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts